<template>
  <div class="evaluate-con">
    <!-- 当是当前用户的评价任务时才显示内容 -->
    <div v-if="shouldShowContent">
      <!-- 添加评价信息显示区域 -->
      <div class="evaluation-info" v-if="hasEvaluationData">
        <div class="info-header">
          <span class="title">订单评价</span>
          <span class="order-id">订单号: {{ evaluationData.orderId }}</span>
        </div>

        <div class="info-section">
          <div class="section-header">套餐信息</div>
          <div class="section-content">
            <div class="info-item">
              <span class="label">服务名称:</span>
              <span class="value">{{ evaluationData.storeName }}</span>
            </div>
            <div class="info-item" v-if="evaluationData.skuName">
              <span class="label">套餐类型:</span>
              <span class="value">{{ evaluationData.skuName }}</span>
            </div>
            <div class="info-item" v-if="evaluationData.sku">
              <span class="label">套餐次数:</span>
              <span class="value">{{ evaluationData.sku }}次</span>
            </div>
            <div class="info-item" v-if="evaluationData.price">
              <span class="label">套餐价格:</span>
              <span class="value price">¥{{ evaluationData.price }}</span>
            </div>
          </div>
        </div>

        <div class="info-section" v-if="evaluationData.coachName">
          <div class="section-header">教练信息</div>
          <div class="section-content">
            <div class="info-item">
              <span class="label">教练姓名:</span>
              <span class="value">{{ evaluationData.coachName }}</span>
            </div>
            <div class="info-item" v-if="evaluationData.coachPhone">
              <span class="label">联系电话:</span>
              <span class="value">{{ formatPhone(evaluationData.coachPhone) }}</span>
            </div>
          </div>
        </div>

        <div class="info-section" v-if="evaluationData.userName">
          <div class="section-header">用户信息</div>
          <div class="section-content">
            <div class="info-item">
              <span class="label">用户姓名:</span>
              <span class="value">{{ evaluationData.userName }}</span>
            </div>
            <div class="info-item" v-if="evaluationData.userPhone">
              <span class="label">联系电话:</span>
              <span class="value">{{ formatPhone(evaluationData.userPhone) }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="score">
        <div
            class="item acea-row row-middle"
            v-for="(item, indexw) in scoreList"
            :key="indexw"
        >
          <div>{{ item.name }}</div>
          <div class="starsList">
            <span
                @click="stars(indexn, indexw)"
                v-for="(itemn, indexn) in item.stars"
                :key="indexn"
                class="iconfont"
                :class="
                item.index >= indexn
                  ? 'icon-shitixing font-color-theme'
                  : 'icon-kongxinxing'
              "
            ></span>
          </div>
          <span class="evaluate">{{
              item.index === -1 ? "" : item.index + 1 + "分"
            }}</span>
        </div>
        <div class="textarea">
          <textarea
              rows="10"
              placeholder="输入您的评价内容（文字在300字以内）"
              v-model="expect"
          ></textarea>
          <div class="list acea-row row-middle">
            <div
                class="pictrue"
                v-for="(item, index) in uploadPictures"
                :key="index"
            >
              <img :src="item" />
              <span
                  class="iconfont icon-guanbi1 font-color-theme"
                  @click="uploadPictures.splice(index, 1)"
              ></span>
            </div>
            <VueCoreImageUpload
                class="btn btn-primary"
                :crop="false"
                compress="80"
                @imageuploaded="imageuploaded"
                :headers="headers"
                :max-file-size="5242880"
                :credentials="false"
                inputAccept="image/*"
                inputOfFile="file"
                :url="url"
                v-if="uploadPictures.length < 8"
            >
              <div
                  class="pictrue uploadBnt acea-row row-center-wrapper row-column"
              >
                <span class="iconfont icon-icon25201"></span>
                <div>上传图片</div>
              </div>
            </VueCoreImageUpload>
          </div>
        </div>
        <div>
          <checkbox v-model="anonymous" shape="square">是否匿名</checkbox>
        </div>
        <div class="evaluateBnt bg-color-theme" @click="submit">立即评价</div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.evaluate-con .score .textarea .list .pictrue.uploadBnt {
  border: 1px solid #ddd;
}

/* 评价信息样式 */
.evaluation-info {
  background-color: #fff;
  border-radius: 12px;
  margin-bottom: 15px;
  padding: 16px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 12px;
  border-bottom: 1px solid #f5f5f5;
  margin-bottom: 12px;
}

.info-header .title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.info-header .order-id {
  font-size: 13px;
  color: #999;
}

.info-section {
  margin-bottom: 15px;
}

.section-header {
  font-size: 15px;
  font-weight: 600;
  color: #0ce6df;
  margin-bottom: 8px;
  padding-left: 8px;
  border-left: 3px solid #0ce6df;
}

.section-content {
  padding-left: 10px;
}

.info-item {
  display: flex;
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 1.5;
}

.info-item .label {
  color: #666;
  width: 80px;
  flex-shrink: 0;
}

.info-item .value {
  color: #333;
  flex: 1;
}

.info-item .value.price {
  color: #ff5500;
  font-weight: bold;
}
</style>
<script>
import { postOrderComment, editOrderComment } from "@api/store";
import { trim, VUE_APP_API_URL } from "@utils";
import { required } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import VueCoreImageUpload from "vue-core-image-upload";
import { Checkbox } from "vant";
import { mapGetters } from "vuex";

const NAME = "GoodsEvaluate";

export default {
  name: NAME,
  components: {
    VueCoreImageUpload,
    Checkbox,
    type: "add",
  },
  props: {},
  data: function () {
    return {
      orderCon: {
        cartProduct: {
          productInfo: {},
        },
      },
      scoreList: [
        {
          name: "服务质量",
          stars: ["", "", "", "", ""],
          index: -1,
        },
        {
          name: "服务态度",
          stars: ["", "", "", "", ""],
          index: -1,
        },
      ],
      url: `${VUE_APP_API_URL}/api/upload`,
      headers: {
        Authorization: "Bearer " + this.$store.state.app.token,
      },
      uploadPictures: [],
      expect: "",
      anonymous: 0,
      unique: this.$route.params.id,
      evaluationData: {},
      isFromInvitation: false,
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    hasEvaluationData() {
      // 判断是否有评价数据需要展示
      return this.evaluationData && (
          this.evaluationData.orderId ||
          this.evaluationData.storeName ||
          this.evaluationData.coachName ||
          this.evaluationData.userName
      );
    },
    // 判断是否为当前登录用户的评价任务
    isCurrentUser() {
      // 如果没有userInfo或评价数据中没有userUid，则返回true（不做限制）
      if (!this.userInfo || !this.evaluationData.userUid) return true;

      // 比较评价数据中的userUid与登录用户的uid是否一致
      return this.evaluationData.userUid == this.userInfo.uid;
    },
    // 判断是否为教练用户
    isCoach() {
      // 如果没有userInfo或评价数据中没有coachName，则返回false
      if (!this.userInfo || !this.userInfo.realName || !this.evaluationData.coachName) return false;

      // 比较评价数据中的coachName与登录用户的realName是否一致
      return this.evaluationData.coachName === this.userInfo.realName;
    },
    // 决定是否应该显示内容
    shouldShowContent() {
      return this.isCurrentUser;
    }
  },
  mounted: function () {
    this.type = this.$route.query.type;
    this.parseUrlParams();
    this.checkCurrentUser();
    // 检查URL中是否包含from=invitation参数
    this.isFromInvitation = this.$route.query.from === 'invitation';
  },
  activated() {
    this.type = this.$route.query.type;
    this.parseUrlParams();
    this.checkCurrentUser();
    // 检查URL中是否包含from=invitation参数
    this.isFromInvitation = this.$route.query.from === 'invitation';
  },
  methods: {
    checkCurrentUser() {
      // 输出调试信息到控制台
      console.log('当前登录用户ID:', this.userInfo ? this.userInfo.uid : '未登录');
      console.log('评价任务用户ID:', this.evaluationData.userUid || '无数据');
      console.log('是否为当前用户:', this.isCurrentUser);
      console.log('当前用户真实姓名:', this.userInfo ? this.userInfo.realName : '未知');
      console.log('评价任务教练姓名:', this.evaluationData.coachName || '无数据');
      console.log('是否为教练用户:', this.isCoach);

      //如果当前评价用户是教练也是用户,则允许评价
      if (this.isCoach && this.isCurrentUser) {
        return;
      }

      // 如果当前用户是教练，则跳转到订单详情页面
      if (this.isCoach && this.evaluationData.orderId) {
        this.$toast({
          message: '您是此订单的教练，正在跳转到订单详情页...',
          type: 'info',
          duration: 2000
        });

        // 跳转到订单详情页
        setTimeout(() => {
          this.$router.push({
            path: `/order/detail/${this.evaluationData.orderId}`,
            query: { userCategory: 2 }
          });
        }, 1500);
        return;
      }

      // 如果不是当前用户且有userUid参数，则给出提示并1秒后关闭窗口
      if (!this.isCurrentUser && this.evaluationData.userUid) {
        this.$toast({
          message: '当前订单不是您的，您没有权限查看当前评论链接，正在返回首页!!!',
          type: 'warning',
          duration: 3000
        });

        // 1秒后返回上一页
        setTimeout(() => {
          this.$router.go(-1);
        }, 2000);
      }
    },
    parseUrlParams() {
      const params = this.$route.query;

      const evaluationData = {
        orderId: params.orderId,

        storeName: params.storeName,
        skuName: params.skuName,
        sku: params.sku,
        price: params.price,

        coachName: params.coachName,
        coachPhone: params.coachPhone,
        coachUid: params.coachUid,

        userUid: params.userUid,
        userName: params.userName,
        userPhone: params.userPhone
      };

      console.log('评价链接参数数据:', evaluationData);

      this.evaluationData = evaluationData;
    },

    // 格式化手机号，中间4位显示为星号
    formatPhone(phone) {
      if (!phone) return '';
      return phone.length === 11 ?
          `${phone.substr(0, 3)}****${phone.substr(7)}` :
          phone;
    },

    stars: function (indexn, indexw) {
      this.scoreList[indexw].index = indexn;
    },
    imageuploaded(res) {
      if (res.errno !== 0) return this.$dialog.error(res.msg || "上传图片失败");
      this.uploadPictures.push(res.link);
    },
    async submit() {
      const expect = trim(this.expect),
          product_score =
              this.scoreList[0].index + 1 === 0 ? "" : this.scoreList[0].index + 1,
          service_score =
              this.scoreList[1].index + 1 === 0 ? "" : this.scoreList[1].index + 1,
          anonymous = this.anonymous ? 1 : 0;
      try {
        await this.$validator({
          product_score: [
            required("请选择服务质量分数", {
              type: "number",
            }),
          ],
          service_score: [
            required("请选择服务态度分数", {
              type: "number",
            }),
          ],
        }).validate({ product_score, service_score });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      console.log("this.type", this.type)
      if (this.type === "edit") {
        editOrderComment({
          productScore: product_score,
          serviceScore: service_score,
          unique: this.unique,
          pics: this.uploadPictures.join(","),
          comment: expect,
          anonymous: anonymous,
          id: this.$route.query.id,
        })
            .then(() => {
              this.$dialog.success("评价成功");
              setTimeout(() => {
                this.$router.push({
                  path: `/order/order_evaluate/${this.evaluationData.orderId}`,
                  query: {
                    userCategory: 1,
                    from: this.isFromInvitation ? 'invitation' : 'evaluate'
                  }
                });
              }, 1000);
            })
            .catch((res) => {
              this.$dialog.error(res.msg);
            });
      } else {
        postOrderComment({
          productScore: product_score,
          serviceScore: service_score,
          unique: this.unique,
          pics: this.uploadPictures.join(","),
          comment: expect,
          anonymous: anonymous,
        })
            .then(() => {
              this.$dialog.success("评价成功");
              setTimeout(() => {
                this.$router.push({
                  path: `/order/order_evaluate/${this.evaluationData.orderId}`,
                  query: {
                    userCategory: 1,
                    from: this.isFromInvitation ? 'invitation' : 'evaluate'
                  }
                });
              }, 1000);
            })
            .catch((res) => {
              this.$dialog.error(res.msg);
            });
      }
    },
  },
};
</script>
